var Container = PIXI.Container;
var Sprite = PIXI.Sprite;
import { IdAssetBundleGrounds } from "../../assetBundles/IdAssetBundleGrounds";
import { IdAssetBundleInitialStatic } from "../../assetBundles/static/IdAssetBundleInitialStatic";
var TilingSprite = PIXI.extras.TilingSprite;
var Texture = PIXI.Texture;
var SCALE_FACTOR = 1.666;
export var getSceneBackgroundPlayerBase = function () {
    var container = new Container();
    var bg = Sprite.fromFrame(IdAssetBundleInitialStatic.FarmBackground_Default);
    var horizon = Sprite.fromFrame(IdAssetBundleInitialStatic.FarmHorizon_Default);
    var tileTexture = Texture.fromFrame(IdAssetBundleGrounds.background_tile);
    // Setting mipmap to false gets rid of artifacts when rendering a tiled sprite.
    tileTexture.baseTexture.mipmap = false;
    var tiledBg = new TilingSprite(tileTexture);
    bg.y = horizon.height;
    tiledBg.y = bg.y + bg.height;
    tiledBg.width = bg.width;
    tiledBg.height = tileTexture.height;
    container.addChild(bg, horizon, tiledBg);
    container.scale.set(SCALE_FACTOR, SCALE_FACTOR);
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/backgrounds/getSceneBackgroundPlayerBase.ts
// module id = 2182
// module chunks = 3